<template>
  <div class='product-ingredient-see--container'>
    <el-drawer :visible.sync='show' :close-on-press-escape='false' :title="`产品成分`"
               append-to-body
               custom-class='product-ingredient-see-drawer'>
      <div class='content'>
        <h3 style="margin-top: 0">{{ info.title || '' }}</h3>
        <div>
          <div v-if="!Array.isArray(info.ingredient_url) || !info.ingredient_url.length">无</div>
          <div v-else>
            <el-image
              v-for="(item,i) in info.ingredient_url" :key="i"
              style="width: 55px; height: 55px;margin-right: 10px;"
              :src="item.url"
              :preview-src-list="[item.url]">
            </el-image>
          </div>
        </div>
        <div v-html="markdown" />
      </div>
      <div style='height: 80px;' />
      <div class='footer'>
        <el-button size='medium' @click='handleReset'>重置解析</el-button>
        <el-button @click="show=false">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>

import MlInput from '../../../components/MlInput/index.vue'
import MlButton from '../../../components/MlButton/index.vue'
import { marked } from 'marked'
import { productIngredientReset } from '@/api/product-ingredients'

export default {
  name: 'ProductIngredientSee',
  components: { MlButton, MlInput },
  data() {
    return {
      loading: false,
      show: false,
      info: {}
    }
  },
  computed: {
    markdown: function() {
      const rawMarkdown = Array.isArray(this.info.propose_ai) ? this.info.propose_ai.join('\n') : (this.info.propose_ai || '')
      return marked.parse(rawMarkdown)
    }
  },
  methods: {
    /**
     * 给父组件用
     * @param obj
     */
    interfaceSee: function(obj) {
      this.handleShowDrawer(obj)
    },
    /**
     * 弹出层
     * @param obj
     */
    handleShowDrawer: async function(obj) {
      this.info = obj
      this.show = true
    },
    handleReset: function() {
      this.$confirm('确认重置该条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await productIngredientReset({ ids: [this.info.id] })
        this.$message.success('操作成功!')
        this.$emit('success')
        this.show = false
      })
    }
  }
}
</script>

<style lang='scss'>
.product-ingredient-see--container {
  display: inline;
}

.product-ingredient-see-drawer {
  width: 1000px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
  }
  /* Markdown 样式 */
  .content {
    h1, h2, h3, h4, h5, h6 {
      margin: 16px 0 8px 0;
      color: #333;
      font-weight: 600;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }

    h5 {
      font-size: 14px;
    }

    h6 {
      font-size: 12px;
    }

    p {
      margin: 8px 0;
      line-height: 1.6;
      color: #666;
    }

    ul, ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
      line-height: 1.6;
    }

    strong {
      font-weight: 600;
      color: #333;
    }

    em {
      font-style: italic;
    }

    code {
      background-color: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9em;
    }

    pre {
      background-color: #f5f5f5;
      padding: 12px;
      border-radius: 4px;
      overflow-x: auto;
      margin: 12px 0;

      code {
        background: none;
        padding: 0;
      }
    }

    blockquote {
      border-left: 4px solid #ddd;
      padding-left: 16px;
      margin: 12px 0;
      color: #666;
      font-style: italic;
    }

    a {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 12px 0;

      th, td {
        padding: 8px 12px;
        border: 1px solid #ddd;
      }

      th {
        background-color: #f5f5f5;
        font-weight: 600;
      }
    }
  }
}
</style>
